import { Box, Typography } from '@mui/material';
import theme from '../../theme';

const SubTab = ({ tabs, activeTab, onTabChange, sx = {} }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: 1.25, lg: 2.5 },
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        ...sx,
      }}
    >
      {tabs.map((tab) => {
        const tabKey = tab.key || tab.id;
        const isActive = activeTab === tabKey;
        return (
          <Box
            key={tabKey}
            onClick={() => onTabChange(tabKey)}
            sx={{
              pb: '5px',
              borderBottom: isActive
                ? `2px solid ${theme.palette.black[9]}`
                : '2px solid transparent',
              cursor: 'pointer',
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 14, lg: 18 },
                fontWeight: isActive ? 700 : 400,
                color: isActive ? theme.palette.black[9] : theme.palette.black[3],
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default SubTab;
